import React from "react";
import './termsconditions.css';

function MPSTermsConditionsCard() {
    const openNewTab = (url) => {
        window.open(url, '_blank');
    };

    return (
        <div style={{ marginLeft: 5, marginRight: 5 }}>
            <p style={{ textAlign: 'center', fontSize: 20 }}>
                <strong>Terms and Conditions</strong>
            </p>

            <p><strong>1. Card Ownership & Use</strong><br />
                The card remains Vodafone’s property. It must be registered under your name and cannot be transferred or used by someone else. Third-party use or upgrades are not allowed.</p>

            <p><strong>2. Balance Storage & Refunds</strong><br />
                Balances are stored directly on the card, offline. Lost or stolen cards cannot be tracked, blocked, or refunded, except for Student Blue Cards (per student), where a police report and a Head of School letter are mandatory for recovery.</p>

            <p><strong>3. Fees & Upgrades</strong><br />
                First card and first replacement: Free<br />
                Each additional card, or replacement after the first: $3 fee<br />
                Upgrades (after 3+ old cards): $3 fee<br />
                Free upgrades require your old card to transfer the balance.</p>

            <p><strong>4. Card Expiry</strong><br />
                Cards do not have an expiry unless required by a system or technology update.</p>

            <p><strong>5. Durability & Malfunctions</strong><br />
                Damaged cards follow the standard replacement rule (1 free, then $3).<br />
                If a card malfunctions within 3 months of issue without physical damage, you’ll receive a free replacement.<br />
                In all cases, bring your old card for balance transfer.</p>

            <p><strong>6. Transaction History</strong><br />
                The last 3 transactions are stored on the card.<br />
                The app shows up to 1 month of top-up and transaction history.</p>

            <p><strong>7. Liability & Top-Ups</strong><br />
                Vodafone is not liable for card loss or damage.<br />
                Top-ups made via mPAiSA, MyCash, or banks follow those providers’ terms.</p>

            <p><strong>8. Dispute Resolution</strong><br />
                Governed under Fijian Law. Disputes may be raised to Vodafone Fiji Customer Care.</p>
        </div>
    );
}

export default MPSTermsConditionsCard;